// extracted by mini-css-extract-plugin
export default {"code":"P_cx"};